import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import * as signalR from "@microsoft/signalr";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Paginations from "../../../components/paginaton/Paginations";

const ShippingArchiveDelivery = () => {
  const { branchId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  // const [shipmentTypes, setShipmentTypes] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showdetailModal, setShowDetailModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    orderNumber: 0,
    cashDeskId: 0,
    saleUnitId: 0,
    categoryId: 0,
    orderType: 0,
    posDeviceId: 0,
    size: 20,
    part: 1,
    invoiceNumber: 0,
    merchantName: "",
    merchantPhone: "",
    merchantCode: "",
    destination: "",
    paymentType: 0,
    orderStatus: 0,
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    total: 0,
    parts: 0,
  });
  const [deliveriesFilterModel, setDeliveriesFilterModel] = useState({
    branchId: branchId,
    firstName: "",
    lastName: "",
    mobile: 0,
    code: 0,
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });

  const [detailItemModel, setDetailItemModel] = useState({
    merchantName: "",
    orderNumber: "",
    phoneNumber: "",
    merchantItem: [],
    totalFinalPrice : "",
  });

  // const getShipmentTypes = async () => {
  //   const resp = await apiMethod.getShipmentTypes();
  //   if (!methods.showApiErrors(resp)) return false;
  //   setShipmentTypes(resp.data);
  // };

  const getOrderTypes = async () => {
    const orderTypesResp = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(orderTypesResp))
      setOrderTypes(orderTypesResp.data);
  };

  const getGridData = async () => {
    const cookedResp = await apiMethod.getDeliveredOrderArchive(
      filterModel.branchId,
      filterModel.orderNumber,
      filterModel.saleUnitId,
      filterModel.cashDeskId,
      filterModel.posDeviceId,
      filterModel.invoiceNumber,
      filterModel.merchantName,
      filterModel.merchantPhone,
      filterModel.merchantCode,
      filterModel.destination,
      filterModel.orderType,
      filterModel.paymentType,
      filterModel.orderStatus,
      filterModel.startDate,
      filterModel.endDate,
      filterModel.part,
      filterModel.size
    );
    if (methods.showApiErrors(cookedResp)) {
      filterModel.total = cookedResp.total;
      setFilterModel({ ...filterModel });
      setGridData(cookedResp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      createConnection();
      // await getShipmentTypes();
      await getBaseInfo();
      await getOrderTypes();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.cashDeskId = 0;
    filterModel.orderNumber = 0;
    filterModel.saleUnitId = 0;
    filterModel.categoryId = 0;
    filterModel.orderType = 0;
    filterModel.posDeviceId = 0;
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.invoiceNumber = "";
    filterModel.merchantName = "";
    filterModel.merchantPhone = "";
    filterModel.merchantCode = "";
    filterModel.destination = "";
    filterModel.paymentType = 0;
    filterModel.orderStatus = 0;
    filterModel.startDate = "";
    filterModel.endDate = "";
    filterModel.total = 0;
    filterModel.parts = 0;
    setFilterModel({ ...filterModel });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const URL =
    process.env.REACT_APP_ROOT_MSG + "/DataHub/?connectionId=" + branchId;
  const createConnection = async () => {
    let conn = new signalR.HubConnectionBuilder()
      .withUrl(URL)
      .withAutomaticReconnect()
      .build();
    await conn
      .start()
      .catch((err) => console.log(err))
      .then(() => {
        conn.invoke("GetConnectionId").then(function (connectionId) {
          console.log("connectionId: " + connectionId);
        });
      });
    conn.on("ReceiveNewOrderPanel", (bid, orderId, status) => {
      if (status === 2) getGridData();
    });
  };

  console.log({"archive:::" : gridData})

  const getBaseInfo = async () => {
    const orderTypesResp = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(orderTypesResp))
      setOrderTypes(orderTypesResp.data);

    const resp2 = await apiMethod.getAllUnits(branchId);
    if (methods.showApiErrors(resp2)) setUnits(resp2.data);
  };
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const mapItemList = (item) => {
    detailItemModel.merchantName = item.merchantName;
    detailItemModel.orderNumber = item.orderNumber;
    detailItemModel.merchantItem = item.invoiceItems;
    detailItemModel.phoneNumber = item.merchantPhone;
    detailItemModel.totalFinalPrice = item.totalFinalPrice
    setDetailItemModel({ ...detailItemModel });
  };

  const showOrderList = (item) => {
    mapItemList(item);
    setShowDetailModal(true);
  };

  console.log(gridData);

  const moduleBinder = () => {
    return (
      <div className="p-4 mx-auto">
        {loading && <Preloading></Preloading>}
        {
          <div className="row bg-light">
            <div
              className={`col-12 ${
                collapsed ? "col-lg-1" : "col-lg-2"
              } border-end border-secondary-subtle p-0 bg-white`}
            >
              <div className="d-flex justify-content-end pt-4">
                <span className="toggleImg" onClick={toggleSidebar}>
                  {collapsed ? (
                    <i className="bi bi-arrow-left-circle fs-5"></i>
                  ) : (
                    <i className="bi bi-arrow-right-circle fs-5"></i>
                  )}
                </span>
              </div>
              <div className="d-flex flex-column gap-3 px-4 mt-5">
                <Link to={`/shipping/${branchId}/delivery`} className="w-100">
                  <button
                    className="btn btn-outline-purple w-100"
                    style={{ fontSize: collapsed ? "12px" : "16px" }}
                  >
                    لیست سفارشات
                  </button>
                </Link>
                <button
                  className="btn btn-purple"
                  style={{ fontSize: collapsed ? "12px" : "16px" }}
                >
                  آرشیو تحویل سفارشات
                </button>
              </div>
            </div>
            <div className="col-12 col-lg-10">
              <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
                <div>
                  <Link to={`/sale/${branchId}/#1`} className="link back-link">
                    <span>
                      <img src={back} className="" alt="return" />
                    </span>
                  </Link>
                  آرشیو تحویل سفارشات
                </div>
                <p className="date">{methods.currentDate()}</p>
              </div>
              <div className="saleheader d-none d-lg-block">
                <p>آرشیو تحویل سفارشات</p>
              </div>
              <div className="salemain">
                <div className="salesearchsection">
                  <div className="row g-3">
                    <div className="col-12 col-md-2">
                      <label htmlFor="funit" className="form-label">
                        نام
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.merchantName}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            merchantName: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-2">
                      <label htmlFor="funit" className="form-label">
                        شماره سفارش
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.orderNumber}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            orderNumber: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-2">
                      <label htmlFor="funit" className="form-label">
                        شماره فاکتور
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.invoiceNumber}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            invoiceNumber: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-2">
                      <label htmlFor="funit" className="form-label">
                        شماره اشتراک
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.merchantCode}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            merchantCode: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-2">
                      <label htmlFor="filters" className="form-label">
                        نوع سفارش
                      </label>
                      <select
                        id="filters"
                        className="form-select"
                        aria-label="menu"
                        value={filterModel.orderType}
                        onChange={(e) => {
                          filterModel.orderType = e.target.value;
                          setFilterModel({ ...filterModel });
                        }}
                      >
                        <option value={0}>همه</option>
                        {orderTypes.map((item, index) => (
                          <option value={item.id} key={index}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                      <label htmlFor="ddlStatuses" className="form-label">
                        بخش های فروش
                      </label>
                      <select
                        id="ddlStatuses"
                        className="form-select"
                        aria-label="menu"
                        value={filterModel.saleUnitId}
                        onChange={(e) => {
                          filterModel.saleUnitId = e.target.value;
                          setFilterModel({ ...filterModel });
                        }}
                      >
                        <option value={0}>همه بخش ها</option>
                        {units.map((item, index) => (
                          <option value={item.id} key={index}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                      <label htmlFor="enddate" className="form-label">
                        از تاریخ
                      </label>
                      <DatePicker
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-center"
                        format="YYYY/MM/DD"
                        value={filterModel.startDate}
                        onChange={(value) => {
                          if (value)
                            filterModel.startDate = value.format("YYYY/MM/DD");
                          else filterModel.startDate = "";
                          setFilterModel({ ...filterModel });
                        }}
                        inputClass="form-control"
                        containerStyle={{
                          width: "100%",
                        }}
                      />
                    </div>
                    <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                      <label htmlFor="enddate" className="form-label">
                        تا تاریخ
                      </label>
                      <DatePicker
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-center"
                        format="YYYY/MM/DD"
                        value={filterModel.endDate}
                        onChange={(value) => {
                          if (value)
                            filterModel.endDate = value.format("YYYY/MM/DD");
                          else filterModel.endDate = "";
                          setFilterModel({ ...filterModel });
                        }}
                        inputClass="form-control"
                        containerStyle={{
                          width: "100%",
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-1 d-flex align-items-end">
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={() => {
                          searchItem();
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="table-responsive text-center">
                  <table className="table table-bordered">
                    <thead className="align-middle">
                      <tr>
                        <th>ردیف</th>
                        <th>نام و نام خانوادگی</th>
                        <th>شماره موبایل</th>
                        <th>شماره فاکتور</th>
                        <th>شماره سفارش</th>
                        <th>شماره اشتراک</th>
                        <th>وضعیت</th>
                        <th>تاریخ و ساعت</th>
                        <th>نوع سفارش</th>
                        <th>آدرس</th>
                        <th>عملیات</th>
                      </tr>
                    </thead>
                    <tbody className="align-middle">
                      {gridData.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.merchantName && item.merchantName.trim() ? item.merchantName : "نامشخص"}</td>
                          <td>{item.merchantPhone ? item.merchantPhone : "..."}</td>
                          <td>{item.invoiceNumber}</td>
                          <td>{item.orderNumber}</td>
                          <td>{item.merchantCode ? item.merchantCode : "..."}</td>
                          <td>{item.orderStatusName}</td>
                          <td>
                            {methods.toPersianDate(
                              item.createDate,
                              "jYYYY/jMM/jDD"
                            )}{" "}
                            - {methods.toPersianDate(item.createDate, "HH:MM")}
                          </td>
                          <td>
                            {
                              orderTypes.find(
                                (orderType) => orderType.id === item.orderType
                              )?.title
                            }
                          </td>
                          <td className="break-text" width={"35%"}>{item.destination ? item.destination : "..."}</td>
                          <td>
                            <button
                              onClick={() => showOrderList(item)}
                              className="btn btn-sm btn-outline-purple"
                              type="button"
                            >
                              <i className="bi bi-file-text"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {filterModel.parts > 1 && (
                    <Paginations
                      total={filterModel.total}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  };

  const detailModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showdetailModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">جزییات سفارش</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setShowDetailModal(false);
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-flex align-items-center justify-content-between">
                <div className="flex align-items-center">
                  <span className="ps-2">نام مشتری:</span>
                  <span>{detailItemModel.merchantName}</span>
                </div>
                <div className="flex align-items-center">
                  <span className="ps-2"> شماره:</span>
                  <span>{detailItemModel.phoneNumber}</span>
                </div>
                <div className="flex align-items-center gap-1">
                  <span className="ps-2"> شماره سفارش:</span>
                  <span>{detailItemModel.orderNumber}</span>
                </div>
              </div>
              <div className="table-responsive text-center mt-3">
                <table className="table table-bordered table-sm align-middle">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center">ردیف</th>
                      <th scope="col vertical-center">تعداد</th>
                      <th scope="col vertical-center">نام کالا</th>
                      <th scope="col vertical-center">قیمت</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {detailItemModel.merchantItem.map((item, index) => (
                      <tr key={item.id}>
                        <td scope="row ">{index + 1}</td>
                        <td>{item.amount}</td>
                        <td>{item.productName}</td>
                        <td>{methods.addNumSeperator(item.finalPrice)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="align-middle">
                    <tr className="fw-bold bg-light">
                      <td colSpan="3" className="text-end">
                        جمع کل:
                      </td>
                      <td>{methods.addNumSeperator(detailItemModel.totalFinalPrice)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {moduleBinder()}
      {showdetailModal && detailModal()}
    </>
  );
};

export default ShippingArchiveDelivery;
